import PropTypes from 'prop-types';
import React from 'react';
import Text from '../Text/index.js';

/**
 *  Describe the component
 *
 */
function OverlineText(_ref) {
  let {
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Text, Object.assign({
    size: 200,
    color: "subdued-lighter",
    transformCase: "uppercase"
  }, rest));
}
export default OverlineText;